
<div class="main-container d-flex flex-wrap" style="text-align: -webkit-center;">
  <div class="col-lg-12 col-md-12">
    <FilterManager
        ref="filterManager"
        :config="config"
        @resetPage="resetPage"
        @refresh="refresh"/>
  </div>
  <div class="col-lg-12 col-md-12">
    <div class="applications__grid" style="margin: 0px;" v-if="!status.get && products && products.length > 0">
      <div class="applications__childs p-0" v-for="(product, index) in products" :key="index">
        <div class="d-flex flex-column" style="height:100%;">
          <a :href="`/productos/${product.slug}`" style=" padding: 10px;">
            <div class="slide-img p-2">
              <img v-if="product.asset && product.asset.slug" :src="`/api/public/v1/assets/${product.asset.slug}`"
                   class="img-fluid">
              <div class="overlay d-flex">
                <a :href="`/productos/${product.slug}`" class="main-button small px-2" style="min-width: auto;">Ver
                  producto</a>
              </div>
            </div>
          </a>
          <div class="detail-box" style="padding: 10px; border-top: 1px solid #c1c1c1;">
            <div class="type col-md-12">
              <label class="col-md-12">
                <a class="text-dark text-center" :href="`/productos/${product.slug}`"
                   style="font-size: 15px;
                                  color: var(--gray-deep__to__gray-light);
                                  overflow-wrap: break-word;display: -webkit-box;
                                  -webkit-line-clamp: 2;-webkit-box-pack: center;-webkit-box-orient:
                                  vertical;overflow: hidden;text-overflow: ellipsis;
                                  "
                >{{ product.name }}</a>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="status.get" class="h-977">
      <div class="spinner-border spinner-border-sm spinner-margin" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div class="row h-977" v-else>
      <div class="col-md-12 text-align-last-center">
        No se han encontrado productos
      </div>
    </div>
    <div class="col-12 my-5" v-if="!status.get">
      <button class="btn btn-light m-2" @click.prevent="pageFilter -= 1" v-if="pageFilter >= 1"><i
          class="fas fa-chevron-left"></i></button>
      <template v-for="(page, index) in pages">
        <button
            v-if="Math.abs(page - pageFilter) <= 1 || (pageFilter == 0 && Math.abs(page - pageFilter) < 3) || (page == 3 && pageFilter < 3)"
            :key="index"
            class="btn btn-light m-2"
            @click.prevent="pageFilter = (page - 1)"
            :class="{
                          active: (pageFilter + 1) === page, 
                          last: (page == pages - 1 && Math.abs(page - pageFilter) >= 3), 
                          first:(page == 0 && Math.abs(page - pageFilter) >= 3)
                      }">
          {{ page }}
        </button>
      </template>
      <button class="btn btn-light m-2" @click.prevent="pageFilter += 1" v-if="pageFilter < ( pages - 1 )"><i
          class="fas fa-chevron-right"></i></button>
    </div>
  </div>
</div>
